import {useContext} from 'react';

import ProjectsContext from '../../contexts/ProjectsContext';

const useProjects = () => {
  return useContext(ProjectsContext);
};

export default useProjects;
